import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { TipoVariable } from './tipoVariable';

import myGlobals = require('../config');

@Injectable()
export class TipoVariableService {

  private tipoVariableUrl = myGlobals.default.BASE_URL + '/tipoVariable/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los tipoVariables habilitados para el usuario
  getTipoVariables() {
    return this.http.get(this.tipoVariableUrl)
      .map((response) => response.json());
  }

  //Obtener un tipoVariable
  getTipoVariable(_id: string): Observable<TipoVariable> {
    return this.http.get(this.tipoVariableUrl + _id)
      .map((response) => response.json());
  }

  //Obtener tipoVariables by sucursal
  getTipoVariableesBySucursal(_id: string) {
    return this.http.get(this.tipoVariableUrl + "sucursal/" + _id)
      .map((response) => response.json());
  }

  save(tipoVariable: TipoVariable): Observable<TipoVariable> {
    if (tipoVariable._id) {
      return this.put(tipoVariable);
    }
    //Seteo estado activo
    tipoVariable.estado = true;
    return this.post(tipoVariable);
  }

  //Desactivar tipoVariable
  delete(tipoVariable: TipoVariable) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoVariableUrl}/${tipoVariable._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nuevo tipoVariable
  private post(tipoVariable: TipoVariable): Observable<TipoVariable> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(tipoVariable);
    console.log(JSON.stringify(tipoVariable));
    var tipoVariableStr = JSON.stringify(tipoVariable);
    return this.http
      .post(this.tipoVariableUrl, tipoVariableStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar tipoVariable
  private put(tipoVariable: TipoVariable) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoVariableUrl}/${tipoVariable._id}`;

    return this.http
      .put(url, JSON.stringify(tipoVariable), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoVariable/tipoVariable.service.ts